import React, { FC } from 'react';
import {
  Table,
  TableHeadCell,
  TableHead,
  TableContentCell,
  TableRow,
} from 'src/modules/global/components/table/Table';
import { ThumbnailAndTitle } from 'src/modules/global/components/table/thumbnail-and-title/ThumbnailAndTitle';
import { ProductLocalizedEntity } from 'src/modules/products';
import { IconImage } from 'src/modules/global/components/icon/Icon';
import Link from 'next/link';
import { ProfessionalsDownloadsProductsStore } from 'src/modules/professionals/downloads/products';
import { BaseStore } from 'src/store';
import { connect } from 'react-redux';
import { useLocale } from 'src/modules/locale';
import InfiniteScroll from 'react-infinite-scroll-component';
import { getProductName } from 'src/modules/products/utils/products';
import { FormattedMessage } from 'react-intl';
import { LoadingOutlined } from '@ant-design/icons';
import { useChannelFilteredData } from 'src/utils/cleanupProducts';

export interface ProductListProps extends ProfessionalsDownloadsProductsStore {}

const ProductList: FC<ProductListProps> = (props) => {
  const { results: rawProducts } = props;
  const { getLocalizedObjects } = useLocale();
  const rawProductsChannelFiltered = useChannelFilteredData(rawProducts);
  const products = getLocalizedObjects<ProductLocalizedEntity>(rawProductsChannelFiltered);

  return (
    <Table>
      <TableHead>
        <TableHeadCell name="name" lg={12} md={12} sm={12} xs={0}>
          <FormattedMessage id="products/downloads/listing/label_name" />
        </TableHeadCell>
      </TableHead>
      <InfiniteScroll
        dataLength={products.length}
        next={null}
        hasMore={false}
        loader={<LoadingOutlined />}>
        {products.map((p) => {
          return (
            <Link
              key={p.id}
              href="/professionals/downloads/products/[slug]"
              as={`/professionals/downloads/products/${p.slug}`}>
              <TableRow>
                <TableContentCell lg={24} md={24} sm={24} xs={24} icon={IconImage.RightArrow}>
                  <ThumbnailAndTitle
                    url={p.assets[0]?.file?.formats?.thumbnail?.url}
                    title={getProductName(p)}
                  />
                </TableContentCell>
              </TableRow>
            </Link>
          );
        })}
      </InfiniteScroll>
    </Table>
  );
};

const mapStateToProps = (state: BaseStore) => {
  return { ...state.professionals.downloads.products };
};

export default connect(mapStateToProps)(ProductList);
